import React from "react";
import "./style.scss";
import errorIcon from "../../assets/icons/errorModalIcon.svg";
import InforIcon from "../../assets/icons/info-icon-svgrepo-com.svg";

function ErrorModal({setModalOpen, handleNavigation, desc, btnText, info = false}) {
  return (
    <div className="error_modal_overlay">
      <div className="errorModalWrapper errorPopupContainer">
        <div className="error_modal_container_top popupMessageTopSection">
          <div className="tick_icon popupIcon">
            <img
              style={{backgroundColor: "white", borderRadius: "50%"}}
              src={info ? InforIcon : errorIcon}
              alt="error"
            />
          </div>
        </div>
        <div className="error_modal_container">
          <div className="error_modal_container_bottom popupMessageBottomSection">
            <div>
              <h1 style={{color: info && "#2091eb"}}>{info ? "Information" : "Error"}</h1>
            </div>
            <div>
              <p>{desc}</p>
            </div>
            <div>
              <button
                style={{backgroundColor: info && "#2091eb"}}
                className="error_modal_close_btn"
                onClick={() => {
                  {
                    setModalOpen && setModalOpen();
                  }
                  {
                    handleNavigation && handleNavigation();
                  }
                }}
              >
                {btnText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorModal;
